import React from 'react';
import { MobileContainer } from '@components/organism/MobileContainer';

import { PrivacyPolicy } from '@components/molecules/PrivacyPolicy';

export function PrivacyPolicyPage() {
    return (
        <MobileContainer>
            <PrivacyPolicy />
        </MobileContainer>
    );
}
